var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFails(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11,
    width: 6,
    height: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14976_40721",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14976_40721)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83412 35.0026C3.58412 35.0026 3.36676 34.9452 3.18203 34.8305C2.99731 34.7161 2.85356 34.5651 2.75078 34.3776C2.63495 34.1943 2.57134 33.9957 2.55995 33.7818C2.54828 33.5679 2.61189 33.3498 2.75078 33.1276L18.9175 5.21094C19.0563 4.98872 19.2161 4.82899 19.3966 4.73177C19.5772 4.63455 19.7786 4.58594 20.0008 4.58594C20.223 4.58594 20.4244 4.63455 20.605 4.73177C20.7855 4.82899 20.9452 4.98872 21.0841 5.21094L37.2508 33.1276C37.3897 33.3498 37.4533 33.5679 37.4416 33.7818C37.4302 33.9957 37.3666 34.1943 37.2508 34.3776C37.148 34.5651 37.0043 34.7161 36.8195 34.8305C36.6348 34.9452 36.4175 35.0026 36.1675 35.0026H3.83412ZM20.175 30.1276C20.5311 30.1276 20.8272 30.007 21.0633 29.7659C21.2994 29.5251 21.4175 29.2265 21.4175 28.8701C21.4175 28.514 21.2969 28.2179 21.0558 27.9818C20.815 27.7457 20.5163 27.6276 20.16 27.6276C19.8038 27.6276 19.5077 27.7482 19.2716 27.9893C19.0355 28.2301 18.9175 28.5287 18.9175 28.8851C18.9175 29.2412 19.038 29.5373 19.2791 29.7734C19.52 30.0095 19.8186 30.1276 20.175 30.1276ZM20.175 25.5026C20.5311 25.5026 20.8272 25.3827 21.0633 25.143C21.2994 24.9036 21.4175 24.6068 21.4175 24.2526V17.4193C21.4175 17.0651 21.2969 16.7682 21.0558 16.5284C20.815 16.289 20.5163 16.1693 20.16 16.1693C19.8038 16.1693 19.5077 16.289 19.2716 16.5284C19.0355 16.7682 18.9175 17.0651 18.9175 17.4193V24.2526C18.9175 24.6068 19.038 24.9036 19.2791 25.143C19.52 25.3827 19.8186 25.5026 20.175 25.5026Z",
    fill: "#E81818",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFails);
export default __webpack_public_path__ + "static/media/icon_fails.0b550fccc65ff351e4c45094d3de0992.svg";
export { ForwardRef as ReactComponent };